module.exports = __webpack_public_path__ + "static/media/bigTilePerson.77f6cfd1.jpg";